import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebService {
  rootService: string = `https://${environment.apiURL}`;
  private _webURL?: string;
  // rootService: string = 'https://8dfnlekuqh.execute-api.us-east-2.amazonaws.com/prod';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get webURL(): string {
    if (!this._webURL) {
      if (isPlatformBrowser(this.platformId)) {
        this._webURL = `https://${window.location.hostname === 'localhost' ? 'test.recimate.com' : window.location.hostname}`;
      } else {
        // Fallback for SSR
        this._webURL = `https://${environment.apiURL}`;
      }
    }
    return this._webURL;
  }
}
